import {translations} from 'presentation/translations-new';
import {AppointmentHistoryContentType} from 'domain/usecases';
import {TypeAttendance} from 'presentation/modules/myAppointments/constants/typeAttendanceEnum';
import {AppointmentHistoryDetailParams} from './types';

const {myAppointmentDetails} = translations['pt-br'].privateFlow.myAppointments;

export const appointmentHistoryDetail = ({
	appointmentId,
	typeAttendance,
	appointmentsList,
}: AppointmentHistoryDetailParams) => {
	const appointmentDetail = appointmentsList.find((item: AppointmentHistoryContentType) =>
		typeAttendance === TypeAttendance.EMERGENCY
			? appointmentId === item.appointmentIdPublic
			: appointmentId === String(item.number),
	);

	if (!appointmentDetail) {
		throw new Error(myAppointmentDetails.errorDetail.notFound);
	}

	return appointmentDetail;
};
